/**
 * Přetransformuje pole s produkty vč. variant na pole variant s produkty
 * 
 * @param products
 */
export const transformProductsToVariants = (products: Array<GQL.IProduct>) => {

  const variants = products.reduce((acc: any, product: GQL.IProduct) => {
    if (product && product.variants) {

      const productVariants = product.variants.reduce((variantAcc: any, variant: GQL.IProductVariant) => {
        variantAcc.push({ ...variant, product: { ...product } });
        return variantAcc;
      }, []);

      acc = [ ...acc, ...productVariants ];
    }
    return acc;
  }, []);

  return variants;
};

/**
 * Transforms the products into a single version of their variants.
 * As opposed to `transformProductsToVariants` it does not result in multiple variants of the same product
 * @param products 
 * @returns 
 */
export const transformProductsToSingleVariant = (products: Array<GQL.IProduct>) => {
  return products.reduce((acc: GQL.IProductVariant[], product: GQL.IProduct) => {
    if (product && product.variants) {
      const primaryVariant = product.variants.find(variant => variant.sku === product.sku) || minSKUVariant(product.variants);
      if (primaryVariant) {
        acc.push({ ...primaryVariant, product: { ...product}});
      }
    }

    return acc;
  }, []);
};

const minSKUVariant = (arr: GQL.IProductVariant[]) => 
  arr.reduce((acc: GQL.IProductVariant | null, variant: GQL.IProductVariant) => {
    if (!acc || !acc.id || variant.sku < acc.sku) {
      return variant;
    }
    return acc;
  }, null);



// WEBPACK FOOTER //
// ./src/helpers/products/transformProductsToVariants.ts